
import {Vue} from "vue-class-component";

export default class BaseFooter extends Vue {
}
